import axios from "axios";
import {settings} from "../config";
import {AuthUser} from "aws-amplify/auth";
import {getTokenService} from "./useTokenService";
export const sendGetUserItemsRequest = async (user:AuthUser) => {
    let email = user.signInDetails?.loginId || ""

    let {token} = getTokenService({user:user})
    //.user?.signInUserSession?.idToken.jwtToken;
    const {data} =  await axios.get(settings.baseUrl + 'AdminBidList/GetUserFreightItems/' + email,
        {headers:{"Authorization":"Bearer " + token()}})

    return (data || []).map((data:any)=>{
            return {
                orderID:data.orderNumber,
                dateReq:data.orderDate,
                shipNumber:data.shipNumber,
                city:data.shipToCity,
                state:data.shipToProv,
                miles: data.distance,
                shipWeight:data.shipWeight,
                hotLoad:data.hotFreight,
                tarpRequired:data.tarpRequired,
                mapLink: `https://maps.google.com/?q=${data.shipToCity},${data.shipToProv}`,
                sendToBoard: data.openForBid,
                shippingStatus:data.shipStatus,
                bookNowRate: data.bookNowRate,
                bidAmount:data.bidAmount
            };
        });

};